import { Box, Skeleton } from "@mui/material";
import { useProgressiveImage } from "../hooks/useProgressiveImage";
import VSNImage from "./VSNImage";

const VSNProgressiveImage = ({
  src,
  alt,
  placeholder,
  className,
  style = {},
  ...props
}) => {
  const { currentSrc, isLoading } = useProgressiveImage(src, placeholder);

  return (
    <Box
      position="relative"
      className={className}
      style={{
        ...style,
        overflow: "hidden",
        width: "100%",
        backgroundColor: "#f0f0f0",
      }}
    >
      {isLoading && (
        <>
          <Skeleton
            variant="rectangular"
            width="100%"
            height="100%"
            animation="wave"
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: 2,
            }}
          />
          {placeholder && (
            <VSNImage
              src={placeholder}
              alt="Placeholder"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                filter: "blur(5px)",
                zIndex: 1,
              }}
              {...props}
            />
          )}
        </>
      )}
      <VSNImage
        src={currentSrc}
        alt={alt}
        className={className}
        style={{
          opacity: isLoading ? 0 : 1,
          transition: "opacity 0.5s ease-in-out",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          ...style,
        }}
        {...props}
      />
    </Box>
  );
};

export default VSNProgressiveImage;
